module.exports = __webpack_public_path__ + "static/bg-3c8e36663cbb608a5f099ca26f2fc985.png";